import ConfirmationDialog from "client/common/components/content/ConfirmationDialog";
import { useCurrentDialog } from "client/common/hooks/stackables";

import { useDeleteDosageReminderMutation } from "../hooks";

export type ReminderDeleteDialogProps = {
  reminderId: number;
  onDeleted: () => void;
};

const ReminderDeleteDialog = ({ reminderId, onDeleted }: ReminderDeleteDialogProps) => {
  const { close } = useCurrentDialog();
  const {
    mutate: deleteReminder,
    isPending: isLoading,
    error,
  } = useDeleteDosageReminderMutation(reminderId, {
    onSuccess: () => {
      close();
      onDeleted();
    },
  });

  return (
    <ConfirmationDialog
      title="Delete this reminder"
      description="Are you sure you want to delete this reminder? This action cannot be undone."
      denyText="Keep reminder"
      confirmText="Delete reminder"
      confirmColor="danger"
      onConfirm={() => deleteReminder()}
      onDeny={close}
      isLoading={isLoading}
      error={error}
    />
  );
};

export default ReminderDeleteDialog;
